import React, { useId } from "react";

/**
 * Icones dos canais — copiados de evolzap/frontend/src/components/icons/*
 * (sistema real) pra que o mockup use exatamente a mesma linguagem visual.
 * Os ids de gradiente usam useId pra nao colidir quando o icone aparece
 * varias vezes na pagina.
 */

export function WhatsAppIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <rect width="24" height="24" rx="6" fill="#25D366" />
      <path
        d="M12.04 5.5c-3.55 0-6.43 2.88-6.43 6.43 0 1.13.3 2.24.86 3.21l-.91 3.36 3.43-.9c.94.51 2 .78 3.05.78h.01c3.55 0 6.43-2.88 6.43-6.43 0-1.72-.67-3.34-1.88-4.55a6.39 6.39 0 00-4.55-1.9zm3.76 9.19c-.16.45-.93.86-1.3.91-.33.05-.76.07-1.22-.08-.28-.09-.64-.21-1.1-.41-1.94-.84-3.21-2.79-3.31-2.92-.1-.13-.79-1.05-.79-2 0-.95.5-1.42.68-1.61.18-.19.39-.24.52-.24.13 0 .26 0 .38.01.12.01.28-.05.44.34.16.4.56 1.38.61 1.48.05.1.08.22.02.34-.06.12-.09.2-.18.31-.09.11-.19.24-.27.32-.09.09-.18.19-.08.37.1.18.45.74.96 1.2.66.59 1.21.77 1.39.86.18.09.29.07.39-.04.1-.11.45-.53.57-.71.12-.18.24-.15.4-.09.16.06 1.04.49 1.22.58.18.09.3.13.34.2.04.07.04.42-.12.87z"
        fill="#fff"
      />
    </svg>
  );
}

export function TelegramIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#26A5E4" />
      <path d="M6.54492 11.952L16.4549 7.99195C17.0449 7.77595 17.4889 8.23195 17.2249 8.79195L14.4289 16.904C14.2489 17.348 13.8049 17.528 13.3849 17.324L9.76092 14.892L8.04492 16.548C7.88892 16.704 7.70892 16.884 7.44492 16.704L7.78092 13.26L14.4529 8.98795C14.7169 8.83195 14.4529 8.47195 14.1409 8.65195L5.86092 13.812C5.38092 14.076 4.86492 13.896 4.75692 13.356L3.79692 9.96001C3.58092 9.19201 4.20492 8.59201 4.94892 8.85601L6.54492 11.952Z" fill="white" />
    </svg>
  );
}

export function FacebookIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <rect width="24" height="24" rx="6" fill="#1877F2" />
      <path d="M15.6 12.75l.42-2.74h-2.63V8.23c0-.75.37-1.48 1.55-1.48h1.2V4.42s-1.09-.19-2.13-.19c-2.17 0-3.59 1.32-3.59 3.7v2.08H8.02v2.74h2.4v6.62a9.6 9.6 0 003 0v-6.62h2.18z" fill="#fff" />
    </svg>
  );
}

// Versao colorida (gradiente oficial) — usada nos canais orbitando o mockup.
export function InstagramIcon(props) {
  const uid = useId().replace(/:/g, "");
  const g1 = `mc-ig-a-${uid}`;
  const g2 = `mc-ig-b-${uid}`;
  const contorno =
    "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.85s-.011 3.584-.069 4.85c-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07s-3.584-.012-4.85-.07c-3.252-.148-4.771-1.691-4.919-4.919-.058-1.265-.069-1.645-.069-4.85s.011-3.584.069-4.85c.149-3.225 1.664-4.771 4.919-4.919C8.416 2.175 8.796 2.163 12 2.163Zm0-2.163C8.74 0 8.333.01 7.053.062 2.695.22 0 2.924 0 7.385c0 1.27.01 1.687.062 2.946.156 3.46.945 5.546 2.946 7.547 2 2 4.087 2.79 7.547 2.946 1.26.052 1.677.062 2.946.062 1.27 0 1.687-.01 2.946-.062 3.46-.156 5.546-.945 7.547-2.946 2-2 2.79-4.087 2.946-7.547.052-1.26.062-1.677.062-2.946s-.01-1.677-.062-2.946C23.78 2.924 21.076.22 16.947.062 15.687.01 15.26 0 12 0Z";
  const lente =
    "M12 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324Zm0 10.162a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z";
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <defs>
        <radialGradient id={g1} cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(20.2 3.8) rotate(118.1) scale(28.3 28.3)">
          <stop stopColor="#F09433" />
          <stop offset="0.5" stopColor="#E6683C" />
          <stop offset="1" stopColor="#DC2743" />
        </radialGradient>
        <radialGradient id={g2} cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(3.8 20.2) rotate(-61.9) scale(28.3 28.3)">
          <stop stopColor="#CC2366" />
          <stop offset="0.5" stopColor="#BC1888" />
          <stop offset="1" stopColor="#AE00FF" />
        </radialGradient>
      </defs>
      <path d={contorno} fill={`url(#${g1})`} />
      <path d={contorno} fill={`url(#${g2})`} />
      <path d={lente} fill={`url(#${g1})`} />
      <path d={lente} fill={`url(#${g2})`} />
      <circle cx="18.406" cy="5.594" r="1.44" fill={`url(#${g1})`} />
      <circle cx="18.406" cy="5.594" r="1.44" fill={`url(#${g2})`} />
    </svg>
  );
}

// Versao contorno — e a que o chat real usa nos avatares (text-pink-500).
export function InstagramOutlineIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
    </svg>
  );
}

export function WebchatIcon(props) {
  return (
    <svg viewBox="0 0 48 48" fill="none" {...props}>
      <rect width="48" height="48" rx="12" fill="#F5B400" />
      <g transform="translate(9, 9) scale(1.25)">
        <path
          d="M3 4 h18 a2 2 0 0 1 2 2 v10 a2 2 0 0 1 -2 2 h-9 l-5 4 v-4 h-4 a2 2 0 0 1 -2 -2 v-10 a2 2 0 0 1 2 -2 z"
          fill="none"
          stroke="#ffffff"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

// Icone "Agentes" da sidebar real (AIIcon).
export function AIIcon({ strokeWidth = 1.5, ...props }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="2" y="4" width="16" height="16" rx="2" ry="2" />
      <path d="M6 16 L8 10 L10 16 M6.5 14 L9.5 14" />
      <line x1="13" y1="10" x2="13" y2="16" />
      <line x1="12" y1="10" x2="14" y2="10" />
      <line x1="12" y1="16" x2="14" y2="16" />
      <path d="M19 3 L19.5 4.5 L21 5 L19.5 5.5 L19 7 L18.5 5.5 L17 5 L18.5 4.5 Z" />
      <path d="M20.5 7.5 L20.75 8.25 L21.5 8.5 L20.75 8.75 L20.5 9.5 L20.25 8.75 L19.5 8.5 L20.25 8.25 Z" />
    </svg>
  );
}

/**
 * Mesmo mapeamento do ChannelIcon do chat real (NovoChatChatPage):
 * instagram aparece em contorno rosa, os demais nos icones coloridos.
 */
export function ChannelIcon({ canal, className = "" }) {
  switch (canal) {
    case "whatsapp":
      return <WhatsAppIcon className={className} />;
    case "telegram":
      return <TelegramIcon className={className} />;
    case "facebook":
      return <FacebookIcon className={className} />;
    case "instagram":
      return <InstagramOutlineIcon className={`${className} text-pink-500`} />;
    case "webchat":
      return <WebchatIcon className={className} />;
    default:
      return null;
  }
}

export const NOME_CANAL = {
  whatsapp: "WhatsApp",
  telegram: "Telegram",
  facebook: "Facebook",
  instagram: "Instagram",
  webchat: "Webchat",
};
